interface NavPathsI {
	HOMEPAGE: string;
	ABOUT: string;
	TEAM: string;
	SERVICES: string;
	CONTACT: string;
}

export const NAV_PATHS: NavPathsI = {
	HOMEPAGE: "/",
	ABOUT: "about",
	TEAM: "team",
	SERVICES: "services",
	CONTACT: "contact",
};
